<template>
  <div :class="['index', { inApp: $root.$data.isApp || $root.$data.isWeiXin }]">
    <common-title
      titleName="新人专区"
      v-if="!($root.$data.isApp || $root.$data.isWeiXin)"
      :bcColor="'#FEFEFF'"
      :goHome='true'
      :zIndex="1000"
    ></common-title>
    <!-- 轮播 -->
    <Banner :bannerList="bannerList" />
    <!-- gift -->
    <div class="gift_box">
      <img
        class="gift-top"
        src="@/assets/img/newUser/gift.png"
        alt=""
      />
      <div class="gift-list">
        <h1 class="title">以下奖品任选一个</h1>
        <div class="gift-detail">
          <div class="courses">
            <!-- 课程 -->
            <CourseCard
              v-for="(item, index) in courseList"
              :key="index"
              :courseInfo="item"
              :receiveStatus="receiveStatus"
              @sendReceive="sendReceive"
            />
          </div>
          <div class="coupons">
            <!--  优惠券-->
            <CouponCard
              v-for="(item, index) in couponList"
              :key="index"
              :couponInfo="item"
              :receiveStatus="receiveStatus"
              @sendReceive="sendReceive"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="video">
      <div
        class="video-info"
        v-if="videoList.length"
      >
        <div class="title">
          <span></span>
          <b>精选视频</b>
          <span></span>
        </div>
        <!-- 视频列表 -->
        <Video :videoList="videoList" />
      </div>
      <div
        class="video-course"
        v-if="recommendCourse.length"
      >
        <div class="title">
          <span></span>
          <b>好课推荐</b>
          <span></span>
        </div>
        <!--  推荐课程-->
        <div class="course">
          <HotCourseCard
            v-for="(item, keys) in recommendCourse"
            :key="keys"
            @click.native="setInfo"
            :item="item"
          />
        </div>
      </div>
    </div>
    <!-- loading -->
    <Loading ref="load" />
    <!-- 领取成功 -->
    <ReceiveSuccess
      :showSuccess="showSuccess"
      :showType="showType"
      :qqUrL="qqUrL"
      @closeSuccess="closeSuccess"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import Banner from '@/pages/arkHome/components/bannerVant.vue';
import Loading from '@/components/loading/loading.vue';
import { reqAcvitityPrize, reqReceivePrize, reqCouponList } from '@/api/newUser';
import { reqAdvertPlaying, reqProducts } from '@/api/home';
import { reqCheckProduct } from '@/api/pay';
import { setTokenFromCookie } from '@/utils/tools';
import CouponCard from './components/couponCard.vue';
import CourseCard from './components/courseCard.vue';
import Video from './components/videoList.vue';
import ReceiveSuccess from './components/receiveSuccess.vue';
import defaultImg from '../../assets/img/loginImg/default.png';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';

export default {
  components: {
    Banner,
    CommonTitle,
    CouponCard,
    CourseCard,
    Video,
    ReceiveSuccess,
    HotCourseCard,
    Loading,
  },
  data() {
    return {
      qqUrL: '', // 社群
      receiving: false, // 优惠券防连点
      bannerList: [],
      couponList: [], // 优惠券
      courseList: [], // 产品
      videoList: [], // 视频列表
      recommendCourse: [], // 推荐的课程列表
      showSuccess: false, // 是否展示领取成功
      activityData: {}, // 23注册活动数据
      defaultImg,
      needAddress: false, // 是否需要添加地址
      receiveStatus: false, // 是否领取过奖品
      showType: 0,
    };
  },
  props: {},

  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  created() {
    this.getBanner();
    this.getActity();
  },
  mounted() { },
  destroyed() {
    sessionStorage.removeItem('addressId');
  },
  methods: {
    // 查询23注册活动
    getActity() {
      const { activeId } = this.$route.query;
      reqAcvitityPrize(activeId)
        .then((res) => {
          const { data } = res;
          const {
            coupons, products, recommendIds, video,
          } = data;
          this.activityData = data;
          this.videoList = video;
          const courseids = products?.map((element) => element.productId);
          this.getCouponDetail(coupons);
          this.getCourseDetail(courseids, 1);
          this.getCourseDetail(recommendIds, 2);
          this.toBuy();
        })
        .catch((error) => {
          // alert(String(error).indexOf('401'));
          if (String(error).indexOf('401') > -1) {
            this.toLogin();
          }
        });
    },
    // 根据优惠券id集合 查询优惠券信息
    async getCouponDetail(couponIds) {
      if (!couponIds) return;
      const ids = `couponId=${couponIds?.map((item) => item.couponId).join('&couponId=')}`;
      const { code, data } = await reqCouponList(ids);
      if (code === 0 && data) {
        const { coupons } = this.activityData;
        coupons.forEach((coupon) => {
          if (coupon.flag) {
            this.receiveStatus = true;
          }
          data.forEach((item) => {
            if (item.couponId === coupon.couponId) {
              Object.assign(item, coupon);
            }
          });
        });
        this.couponList = data;
      }
    },
    // 根据课程id集合 查询课程信息
    async getCourseDetail(productIds, type) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const { code, data } = await reqProducts(productIds, endPoint);
      if (code === 0 && data) {
        data.forEach((item) => {
          const { productDiscountRespVO, teacherRespVOS } = item;
          Object.assign(item, {
            salesVolume: Number(item.realSales) + Number(item.initialSales),
            courseBeginTime: item.startTime, // 开课时间
            isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
            isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
            teacherRespVOS: teacherRespVOS?.map((teacher) => ({
              teacherHead: teacher.teacherHead ? teacher.teacherHead : this.defaultImg,
              name: teacher.name,
            })),
          });
          if (
            productDiscountRespVO?.isCouponDiscount
            && productDiscountRespVO?.couponDiscount
            && item.sellPrice > 0
            && !productDiscountRespVO?.promotionLabel
          ) {
            Object.assign(item, {
              promotionLabel: 4,
              originalPrice: item.sellPrice,
              sellPrice: productDiscountRespVO.discountPrice,
            });
          }
          if (productDiscountRespVO?.promotionLabel) {
            Object.assign(item, {
              promotionLabel: productDiscountRespVO?.promotionLabel,
              originalPrice: (Number(productDiscountRespVO.discountMinPrice)
                + Number(productDiscountRespVO.discountAmount)).toFixed(2),
              sellPrice: productDiscountRespVO.discountMinPrice,
              acvitityShowTime: productDiscountRespVO?.promotionShowTime,
              acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
              acvitityEndTime: productDiscountRespVO?.promotionEndTime,
            });
          }
        });

        if (type === 1) {
          this.activityData.products.forEach((course) => {
            if (course.flag) {
              this.receiveStatus = true;
            }
            data.forEach((item) => {
              if (item.productId === course.productId) {
                Object.assign(item, course);
              }
            });
          });
          this.courseList = data;
        } else {
          this.recommendCourse = data;
        }
      }
    },
    toBuy() {
      const data = sessionStorage.getItem('RECEIVEPRICE');
      const addressId = sessionStorage.getItem('addressId');
      if (data && addressId) {
        this.sendReceive(JSON.parse(data));
      }
    },
    // 轮播图
    async getBanner() {
      const adcode = 'xryl00001';
      const res = await reqAdvertPlaying([adcode]);
      this.bannerList = res.data?.find(
        (item) => item.adCode === adcode,
      )?.advertisingContentWebInfoRespVOS;
    },
    async sendReceive(receiveData) {
      sessionStorage.setItem('RECEIVEPRICE', JSON.stringify(receiveData));
      const { type, item } = receiveData;
      this.showType = type;
      const { productId, productSkuId, id } = item;
      const { activeId } = this.$route.query;
      if (!this.userInfo?.id) this.toLogin();
      if (type === 1) {
        // 校验是否需要添加地址
        const subData = {
          products: [
            {
              productId,
              productSkuId,
              quantity: 1,
              type: 1,
            },
          ],
          userId: this.userInfo.id,
        };
        const { code, data } = await reqCheckProduct(subData);
        if (
          code === 0
          && data.addressBeforeOrder
          && data.needAddress
          && !sessionStorage.getItem('addressId')
        ) {
          this.needAddress = true;
          this.addAddress();
        } else {
          this.receivePrice(activeId, id, type);
        }
        //
      } else {
        this.receivePrice(activeId, id, type);
      }
    },
    // 领奖品
    async receivePrice(activeId, prizeId, type) {
      const params = {
        id: activeId,
        // eslint-disable-next-line no-undef
        ip: sessionStorage.getItem('cityIp') || '',
        prizeId,
        terminalMark: this.$global.terminalMark,
        type,
        userAddressId: sessionStorage.getItem('addressId'),
      };
      const { code, data, msg } = await reqReceivePrize(params);
      if (code === 0) {
        // console.log(data, 1111);
        this.showSuccess = true;
        this.qqUrL = data.qrCode;
        sessionStorage.removeItem('addressId');
        sessionStorage.removeItem('RECEIVEPRICE');
        this.getActity();
      } else {
        this.$toast(msg);
      }
    },
    toLogin() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login', {}, true)
          .then(async () => {
            setTokenFromCookie();
            await this.$root.getUserInfo();
          })
          .catch((err) => console.log(err.toString()));
      } else {
        const queryParam = { redirect: '/newUserZone', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: queryParam });
        // this.$router.push({
        //   path: '/registrationLogin',
        //   query: {
        //     redirect: this.$route.path,
        //     ...this.$route.query,
        //   },
        // });
      }
    },
    addAddress() {
      this.$router.push({
        path: '/personalCenter/address',
        query: {
          needBack: true,
        },
      });
    },

    closeSuccess() {
      this.showSuccess = false;
    },
    setInfo() {
      sessionStorage.setItem('back', true);
    },
  },
};
</script>
<style scoped lang="scss">
.index {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  padding-bottom: 100px;
  background: #f9f9f9;
  &.inApp {
    padding-top: 40px;
    padding-bottom: 0;
  }
}
.gift_box {
  width: 670px;
  margin: 0 auto;
  .gift-top {
    width: 670px;
    height: 270px;
  }
  .gift-list {
    position: relative;
    top: -55px;
    width: 100%;
    padding-bottom: 20px;
    background: #ff3219;
    border-radius: 0 0 8px 8px;
    .title {
      padding: 20px 0;
      color: #ffe1cc;
      font-weight: 300;
      font-size: 30px;
      text-align: center;
    }
    .gift-detail {
      width: 638px;
      margin: 0 auto;
      padding: 24px 0;
      background: #fff;
      border-radius: 6px;
    }
  }
}
::v-deep .banner {
  padding: 0 40px 26px;
}
.video {
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 84px;
      height: 2px;
      background: #ffe1cc;
    }
    b {
      padding: 0 48px;
      color: #ff6c02;
      font-weight: 500;
      font-size: 32px;
    }
  }
}
.course {
  padding: 40px;
}
.video-course {
  padding-top: 20px;
}
</style>
